import { site_url } from '@/constants/Functions'
import { InertiaLink } from '@inertiajs/inertia-react'
import React from 'react'
import {PREFIX_NAME_APP, PREFIX_NAME_MANAGER_ROUTING} from '@/constants/Site'

const Link = React.forwardRef(({href, link, linkParams=[], prefix=PREFIX_NAME_APP, exact, linkAs, ...props}, ref) => {
    if (typeof hef === "string" && href.startsWith("/")) {
        href = site_url(href);
    }
    if (typeof href=='undefined' && link) {
    	if (!exact && prefix) link = prefix + link;
    	href = route(link, ...linkParams);
    }
    return <InertiaLink as={linkAs} href={href} {...props} ref={ref} />
})

export default Link

/* ================ EXTRA LINKS ================= */

export const IntranetLink = React.forwardRef((props, ref) => {
    return <Link prefix={PREFIX_NAME_MANAGER_ROUTING} {...props} ref={ref}  />
})

